import template from './dynamicEvents.modal.component.html';

/* @ngInject */
function controller(
  $uibModalInstance,
  growl,
  site,
) {
  const vm = this;

  vm.gatherers = [];
  vm.open = open;
  vm.opened = false;
  vm.pipelines = _.get(site, 'info.pipelines', []);
  vm.selected = new Date();
  vm.title = `Create P18 Report for ${site.name}`;

  vm.save = () => $uibModalInstance.close(getPdfOptions());

  vm.dismiss = () => {
    $uibModalInstance.dismiss('closed');
  };

  vm.addGathererFields = () => vm.gatherers.length >= 4 ?
    growl.error('Only 4 Gatherers allowed on P18. Please be sure to combine purchases by the same gatherer.') :
    vm.gatherers.push({
      name: '',
      soldAmount: '',
      rrcNo: ''
    });

  function open($event) {
    $event.preventDefault();
    $event.stopPropagation();
    vm.opened = true;
  }

  /**
   * Retrieve and process requested pdf report options
   *
   * @returns {object} Contains data required by API to generate a proper P-18 Report
   */
  function getPdfOptions() {
    const { selected, gatherers, pipelines } = vm;
    return {
      reportMonth: selected,
      gatherers,
      pipelines,
      isCorrected: Boolean(vm.isCorrected),
      includePending: Boolean(vm.includePending),
      siteId: site.id,
    };
  }
}


export default {
  name: 'dynamicEventsModal',
  template,
  controller,
  controllerAs: '$modal'
};
